import { THealthDomainScores } from '@/types/Health.types';
import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';
import { TScreenerFormForBE } from '@/utils/screenersScores';

export const lastScoresGet = async (): Promise<THealthDomainScores> => {
  const { data } = await api.get(apiPaths.result.last);
  return data.data;
};

export const createAssessmentResultPost = async ({
  assessmentId,
  totalScore,
  scoresPerDomain,
  subdomainScores,
  readiness,
  critical,
  domainQuestionsWithValues,
}: TScreenerFormForBE & {
  assessmentId: string;
  totalScore: number;
}): Promise<unknown> => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(apiPaths.result.create, {
    assessmentId,
    totalScore,
    scores: scoresPerDomain,
    subdomainScores,
    readiness,
    critical,
    data: domainQuestionsWithValues,
  });

  const response = data.data;

  return response;
};
